/* =========================================================
   FX Swatch Picker — Commune SG (added 23 Sep 2026)
   - Desktop: hovering a swatch shows a large preview card
     to the left of the product info column.
   - All devices: tapping the thumbnail in the info panel opens
     the selected swatch as a centred preview.
   Re-initialises automatically after product hot-reload because
   <fx-swatch-picker> is a custom element (connectedCallback).
   ========================================================= */
(function () {
  if (window.customElements && customElements.get('fx-swatch-picker')) return;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var card, backdrop, els = {}, hideTimer, cur = null;

  function ensureCard() {
    if (card) return card;
    card = document.createElement('div');
    card.className = 'fx-preview';
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-hidden', 'true');
    card.innerHTML =
      '<button type="button" class="fx-preview__close" aria-label="Close">&times;</button>' +
      '<div class="fx-preview__img"></div>' +
      '<div class="fx-preview__body">' +
        '<p class="fx-preview__name"></p>' +
        '<p class="fx-preview__family" hidden></p>' +
        '<div class="fx-preview__comp" hidden><p class="fx-preview__h">Composition</p><p class="fx-preview__p"></p></div>' +
        '<div class="fx-preview__care" hidden><p class="fx-preview__h">Care</p><p class="fx-preview__p"></p></div>' +
      '</div>';
    backdrop = document.createElement('div');
    backdrop.className = 'fx-preview-backdrop';
    document.body.appendChild(backdrop);
    document.body.appendChild(card);

    els.img = card.querySelector('.fx-preview__img');
    els.name = card.querySelector('.fx-preview__name');
    els.family = card.querySelector('.fx-preview__family');
    els.comp = card.querySelector('.fx-preview__comp');
    els.care = card.querySelector('.fx-preview__care');

    card.querySelector('.fx-preview__close').addEventListener('click', hide);
    backdrop.addEventListener('click', hide);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    window.addEventListener('scroll', function () { if (!card.classList.contains('is-modal')) hide(); }, { passive: true });
    window.addEventListener('resize', hide);
    return card;
  }

  function imageFor(label) {
    if (label.dataset.fxLarge) return 'url("' + label.dataset.fxLarge + '")';
    var cs = getComputedStyle(label);
    var lg = cs.getPropertyValue('--fx-swatch-lg').trim();
    if (lg) return lg;
    return cs.backgroundImage && cs.backgroundImage !== 'none' ? cs.backgroundImage : '';
  }

  function fill(label) {
    ensureCard();
    var d = label.dataset;
    var bg = imageFor(label);
    els.img.style.backgroundImage = bg || '';
    els.img.style.backgroundColor = bg ? '' : getComputedStyle(label).backgroundColor;
    els.name.textContent = d.fxName || '';
    els.family.textContent = d.fxFamily || '';
    els.family.hidden = !d.fxFamily;
    els.comp.hidden = !d.fxComposition;
    els.comp.querySelector('.fx-preview__p').textContent = d.fxComposition || '';
    els.care.hidden = !d.fxCare;
    els.care.querySelector('.fx-preview__p').textContent = d.fxCare || '';
  }

  function show() {
    clearTimeout(hideTimer);
    card.classList.add('is-visible');
    card.setAttribute('aria-hidden', 'false');
  }

  function hide() {
    cur = null;
    if (!card) return;
    card.classList.remove('is-visible');
    card.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('is-visible');
    hideTimer = setTimeout(function () { card.classList.remove('is-modal'); }, 160);
  }

  function showHover(picker, label) {
    fill(label);
    card.classList.remove('is-modal');
    card.style.left = card.style.top = '';

    var gap = 24, margin = 16;
    var pRect = picker.getBoundingClientRect();
    var sRect = label.getBoundingClientRect();
    var w = card.offsetWidth;
    var h = card.offsetHeight;

    var left = pRect.left - w - gap;           // sit over the gallery column
    if (left < margin) { hide(); return; }     // not enough room: skip hover card

    var top = sRect.top + sRect.height / 2 - h / 2;
    top = Math.max(margin, Math.min(top, window.innerHeight - h - margin));

    card.style.left = left + 'px';
    card.style.top = top + 'px';
    show();
  }

  function showModal(label) {
    fill(label);
    card.classList.add('is-modal');
    backdrop.classList.add('is-visible');
    show();
    card.querySelector('.fx-preview__close').focus({ preventScroll: true });
  }

  class FxSwatchPicker extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      var picker = this;

      this.addEventListener('mouseover', function (e) {
        if (!canHover.matches) return;
        var label = e.target.closest('label.fx-swatch');
        if (!label || !picker.contains(label) || label === cur) return;
        cur = label;
        showHover(picker, label);
      });
      this.addEventListener('mouseleave', hide);
      var grid = this.querySelector('.fx-swatches__grid');
      if (grid) grid.addEventListener('scroll', hide, { passive: true });
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fx-open-selected]');
        if (btn) {
          e.preventDefault();
          var checked = picker.querySelector('input[type=radio]:checked + label.fx-swatch');
          if (checked) showModal(checked);
          return;
        }
        if (e.target.closest('label.fx-swatch')) hide();   // choosing a swatch closes the card
      });
    }
  }

  customElements.define('fx-swatch-picker', FxSwatchPicker);
})();
